import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "23d886cb-39ec-430a-97c8-586eaad3a529",
  publicId: "12",
  name: "Electromechanical source: the shaker",
  difficulty: 2,
  contentTypes: { audio: false, interactive: false, video: true },
  body: [principle01, task01, task02, task03],
};

export default lesson;
